export default __webpack_public_path__ + "static/media/icon-voirPlus.0456838f.svg";